import React, { useState } from 'react';
import { Form, Input, Modal, Row, Col, Select } from 'antd';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

const AddDeviceModal = (props) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const [selectedValues, setSelectedValues] = useState([]);
  const [userType, setUserType] = useState(null);

  const onFinish = (values) => {
    values.rooms = _.join(selectedValues, ',');
    props.action(values);
    form.resetFields();
    props.close();
  };

  const handleUserTypeChange = (value) => {
    setUserType(value);
  };

  return (
    <Modal
      title={t("UserPage.addUser")}
      open={props.visible}
      onOk={() => form.submit()}
      onCancel={props.close}
    >
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
      >
        <Row gutter={16}>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("UserPage.table.username")}
              name="username"
              rules={[{ required: true, message: t("UserPage.validation.username") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("UserPage.table.fullName")}
              name="fullname"
              rules={[{ required: true, message: t("UserPage.validation.fullname") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("UserPage.table.email")}
              name="email"
              rules={[{ required: true, message: t("UserPage.validation.email") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("UserPage.table.phone")}
              name="phone"
              rules={[{ required: true, message: t("UserPage.validation.phone") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={t("UserPage.table.type")}
              name="usertype"
              rules={[{ required: true, message: t("UserPage.validation.type") }]}
            >
              <Select placeholder={t("Select") } onChange={handleUserTypeChange}>
                <Select.Option value={1}>{t("Admin")}</Select.Option>
                <Select.Option value={0}>{t("User")}</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          {userType === 0 && (
            <Col span={24}>
              <Form.Item
                label={t("UserPage.table.assignRoom")}
                rules={[{ message: t("UserPage.validation.assignRoom") }]}
              >
                <Select
                  mode="multiple"
                  placeholder={t("Select")}
                  value={selectedValues}
                  onChange={setSelectedValues}
                  options={props.suggestions}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
};

export default AddDeviceModal;
